module.exports = __webpack_public_path__ + "media/images/contest_voter_campaigns/line-icon-207e9038ddd44dd48dd30dc0e40106c5.png";